import Vue from 'vue'

export const setLayout = (state, payload) => {
  Vue.set(state, 'layout', payload)
}
export const setTheme = (state, payload) => {
  Vue.set(state, 'theme', payload)
  localStorage.setItem(process.env.VUE_APP_CLIENT_ID + '-theme', payload)
}
export const setSidebar = (state, payload) => {
  Vue.set(state, 'sidebar', payload)
}
export const setMenu = (state, payload) => {
  Vue.set(state, 'menu', payload)
}
export const setMenuOriginal = (state, payload) => {
  Vue.set(state, 'menuOriginal', payload)
}
